var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "announcement-banner-component" },
        [
          _c(
            "div",
            { staticClass: "announcement-content" },
            [
              _c("KmIcon", {
                staticClass: "mr-2",
                attrs: { name: "km-icon-mcp", size: 18 },
              }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm.mcpRoute
                ? _c(
                    "VBtn",
                    {
                      staticClass: "my-0 ml-3",
                      attrs: {
                        to: _vm.mcpRoute,
                        small: "",
                        round: "",
                        outline: "",
                        color: "white",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.dismiss.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n      Discover\n    ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "VBtn",
            {
              staticClass: "close-button ma-0",
              attrs: { small: "", icon: "", title: "Dismiss" },
              on: { click: _vm.dismiss },
            },
            [_c("KmIcon", { attrs: { name: "km-icon-close", size: 10 } })],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("b", [_vm._v("New — MCP integration:")]),
      _vm._v(
        " connect Claude, Cursor or any AI assistant to your PM2.io\n      monitoring data.\n    "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }